<img style="width: 22px; height: 22px; position: absolute; top: 20px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
<div style="background-color: #F5F7F8; height: 92vh; overflow-y: scroll; padding: 10px;;">
    <h2 style="text-align: center;">Покани приятели</h2>
    <p style="color: #ADAFBB; text-align: center; width: 70%; margin: auto;">
        *Изберете контактите, които искате да поканите. За всеки трима от тях, които се регистрират, ще получите ваучер на стойност 5 лв.
    </p>
    <p style="color: #ADAFBB; margin-bottom: 20px; margin-top: 20px;">
        Избрани контакти
    </p>
    <div *ngFor="let contact of this.selectedContacts; index as i" [style]="this.getStyle(i, this.selectedContacts)">
        <div class="form-check">
            <input style="position: relative; top: 25px;" class="form-check-input" type="checkbox" value=""  [checked]="contact.selected" (change)="this.toggle($event, contact)">
            <img src="/assets/images/account/avatar.svg" alt="" style="margin-left: 20px">
            <label class="form-check-label" style="font-weight: bold; margin-left: 20px">
                <div style="display: inline-block; margin-left: 20px; position: relative; top: 10px;">
                    <p style="font-style: bold;">{{ contact.name }}</p>
                    <p style="color: #ADAFBB; margin-top: 10px;">{{ contact.phone.value }}</p>
                </div>
            </label>
        </div>
    </div>
    <p style="color: #ADAFBB; margin-bottom: 20px; margin-top: 20px;">
        Контакти
    </p>
    <div *ngFor="let contact of this.notSelectedContacts; index as i" [style]="this.getStyle(i, this.notSelectedContacts)">
        <div class="form-check">
            <input style="position: relative; top: 25px;" class="form-check-input" type="checkbox" value=""  [checked]="contact.selected" (change)="this.toggle($event, contact)">
            <img src="/assets/images/account/avatar.svg" alt="" style="margin-left: 20px">
            <label class="form-check-label" style="font-weight: bold; margin-left: 20px">
                <div style="display: inline-block; margin-left: 20px; position: relative; top: 10px;">
                    <p style="font-style: bold;">{{ contact.name }}</p>
                    <p style="color: #ADAFBB; margin-top: 10px;">{{ contact.phone.value }}</p>
                </div>
            </label>
        </div>
    </div>
</div>
<div *ngIf="this.selectedContacts.length" style="position: fixed;  bottom: 5px; text-align: center; width: 90%; margin: auto; left: 5%;">
    <button type="button" class="btn btn-primary" style="width: 90%; margin: auto;" (click)="this.invitePerson()"> {{ "Изпрати " + this.selectedContacts.length + " покани"}} </button>
</div>
